import FormCreateDictionary from './FormCreateDictionary';



export default FormCreateDictionary;
